import router from './router'
import store from './store'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import { isPathMatch } from '@/utils/validate'
import { isRelogin } from '@/utils/request'


const whiteList = ['/login', '/register', '/forgot-password']

const isWhiteList = (path) => {
    return whiteList.some(pattern => isPathMatch(pattern, path))
}

router.beforeEach((to, from, next) => {
    if (getToken()) {
        /* has token*/
        if (to.path === '/login') {
            next({ path: '/' })
        } else if (isWhiteList(to.path)) {
            next()
        } else {
            if (!store.getters.username) {
                isRelogin.show = true
                // 判断当前用户是否已拉取完user_info信息
                store.dispatch('GetInfo').then(() => {
                    isRelogin.show = false
                    
                    // 检查是否访问管理员路由
                    if (to.path.startsWith('/admin')) {
                        if (!store.getters.isAdmin) {
                            next({ path: '/', replace: true })
                            return
                        }
                    }
                    
                    next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
                }).catch(err => {
                    store.dispatch('LogOut').then(() => {
                        Message.error(err)
                        next({ path: '/' })
                    })
                })
            } else {
                // 检查是否访问管理员路由
                if (to.path.startsWith('/admin')) {
                    if (!store.getters.isAdmin) {
                        // 非管理员访问管理员页面，跳转到首页并提示
                        Message.error('您没有权限访问管理后台')
                        next({ path: '/', replace: true })
                        return
                    }
                }
                next()
            }
        }
    } else {
        // 没有token
        if (isWhiteList(to.path)) {
            // 在免登录白名单，直接进入
            next()
        } else {
            next(`/login?redirect=${encodeURIComponent(to.fullPath)}`) // 否则全部重定向到登录页
        }
    }
})

